export default {
  okr: {
    createOkr: '創建目標',
    copyOkr: '復製目標',
    editOkr: '編輯目標',
    alignTarget: '對齊目標',
    targetName: '目標名稱',
    fromOkrDemoAdd: '從案例庫添加',
    inputOkrName: '請輸入目標名稱',
    reminderUpdateOkr: '提醒成員更新目標計劃',
    keyResults: '關鍵成果',
    addKeyResults: '添加關鍵成果KR',
    OnlyMembersLook: '僅相關成員可見',
    OnlyDepartmentLook: '僅部門可見',
    customVisibleRange: '自定義可見範圍',
    targetNameRequired: '目標名稱必填',
    targetcycleRequired: '目標周期必填',
    k_r_NameRequired: '關鍵成果，KR名稱必填',
    k_r_s_e_Required: '關鍵成果，KR起止時間必填',
    annual: '年度',
    firstQuarter: '第一季度',
    secondQuarter: '第二季度',
    thirdQuarter: '第三季度',
    fourthtQuarter: '第四季度',
    okrTime: '目標時間',
    okrState: '目標狀態',
    okrPer: '目標負責人',
    allOkr: '全部目標',
    allCycle: '全部周期',
    clearOption: '清空選項',
    remberOption: '記住選項',
    leastOneChoooseKR: '最少選擇一個KR',
    leastOneChoooseOKROrKR: '最少選擇一個目標或KR',
    leastOneChoooseOKR: '最少選擇一個目標',
    relevanceKr: '關聯KR',
    okrScreen: '目標篩選',
    changeOkr: '切換目標',
    isDangerous: '有風險',
    HasBeenPostponed: '已延期',
    abnormal: '異常',
    createKr: '創建KR',
    createTask: '創建任務',
    s_s_kr: '所屬KR',
    selectKR: '選擇關聯KR',
    set_s_e_time: '設置起止時間',
    targetValue: '目標值',
    workingHours: '預估工時',
    RequiredPerson: '負責人必填',
    p_s_r_kr: '請選擇關聯KR',
    taskNameRequired: '任務名稱必填',
    t_v_2: '目標值最多2位小數',
    w_t_1: '預估時間最多1位小數',
    p_i_title_c_task: '輸入標題新建任務',
    okrTarget: '戰略管理',
    targetPlan: '目標計劃',
    project_z_x: '項目執行',
    checkReject: '校驗駁回',
    resetCheck: '重新校驗',
    kr_progross: 'KR完成度',
    x_x_z_s: '信心指數',
    autoUpdate: '自動更新',
    editProgross: '點擊修改進度',
    s_e_time: '起止時間',
    kr_q_z: 'KR權重',
    kr_p_f: 'KR評分',
    click_edit: '點擊修改',
    p_f_remark: '評分說明',
    not_p_f_remark: '暫無評分說明',
    j_z: '進展',
    f_p: '復盤',
    input_j_z: '填寫進展',
    fillPerson: '填寫人',
    add_j_z: '添加了進展',
    kr_c_p: 'KR當前進度為',
    j_z_date: '進展日期',
    allOperation: '全部操作',
    add_f_p: '添加復盤',
    screen_time: '篩選時間',
    p_f: '評分',
    p_j: '評價',
    delete_j_z_r: '確定要刪除該進展說明嗎？',
    j_z_remark: '進展說明',
    kr_p_f_r: 'KR評分必填',
    kr_p_j_r: 'KR評價必填',
    p_f_detail: '評分詳情',
    is_check: '是否校驗',
    not_check: '不校驗',
    delete_kr_goon: '此操作將永久刪除該KR, 是否繼續？',
    input_p_f_j: '請輸入評分評價',
    is_reset_check: '是否重新開啟校驗？',
    check_status: '校驗狀態',
    to_check: '待校驗',
    input_pass_c: '請輸入通過原因',
    input_reject_c: '請輸入駁回原因',
    kr_name: 'KR名稱',
    s_y_time: '剩余',
    g_q_time: '已過期',
    kr_tip_1: '添加KR：盡量少用「參與」、「幫助」、「分析」這類難以衡量結果的詞匯',
    kr_tip_2: '添加KR：你的KR可以用數字來衡量嗎？',
    kr_tip_3: '添加KR：對自己狠一點，寫一個清晰可衡量的KR',
    kr_tip_4: 'KR要可衡量，不寫「混水摸魚」式KR',
    kr_tip_5: 'KR是結果來描述，不是待辦任務',
    alignment_my: '對齊我的',
    okr: '目標',
    remind_per_update_okr: '提醒成員更新計劃',
    remind_up_look: '提醒上級查看',
    copyOkr_1: '復製目標',
    stopOkr: '結束目標',
    resetOkr: '重啟目標',
    editOkr_1: '編輯目標',
    deleteOkr: '刪除目標',
    select_d_q_okr: '選擇對齊目標',
    system_auto_kr: '系統根據KR進度和權重自動進行計算',
    c_e_q: '點擊修改權重',
    krTask: 'KR任務',
    add_keyResults: '添加關鍵結果',
    sure_stop_okr: '確定要結束該目標嗎？',
    sure_reset_okr: '確定要重啟該目標嗎？',
    okr_state: '目標狀態',
    sure_del_okr: '確定要刪除該目標嗎？刪除後目標以及目標下的KR和任務將同時刪除。',
    d_z_per: '點贊人',
    complete_pro: '完成度',
    x_g_per: '相關人員',
    l_h: '量化',
    s_j_z: '實際值',
    normal: '正常',
    j_j: '緊急',
    f_c_j_j: '非常緊急',
    max_progress_100: '進度最大值為100',
    max_weight_100: '權重最大值為100%',
    progress_100_is_complete: '任務進度已達100%，是否將任務狀態更改為已完成？',
    task_p_range_100: '任務進度可選範圍0-100',
    add_task: '添加任務',
    update_for: '更新於',
    folder: '文件夾',
    by_create_time: '按創建時間',
    by_start_time: '按開始時間',
    by_end_time: '按結束時間',
    all_state: '所有狀態',
    file: '文件',
    all_d_t: '全部動態',
    all_files: '全部文件',
    create_kr: '創建關鍵成果KR',
    change_k_b_view: '切換為看板視圖',
    checking: '校驗中',
    progress_normal: '進度正常',
    progress_risks: '進度有風險',
    progress_postponed: '進度已延期',
    progress_abnormal: '進度異常',
    s_s_o: '所屬',
    schedule_task: '計劃任務',
    weight: '權重',
    current_progress: '當前進度',
    progress_s: '進度說明',
    input_progress_s: '請輸入進度反饋說明',
    update_kr_progress: '更新KR權重',
    update_kr_weight: '更新KR進度',
    update_okr_weight: '更新目標進度',
    all_target_task: '全部目標任務',
    task_time: '任務時間',
    task_status: '任務狀態',
    my_x_z: '我協作的',
    sys_def_sort: '系統默認排序',
    okr_dep_c_p: '各部門目標平均完成度',
    okr_all_c_p: '目標整體平均完成度',
    task_num: '任務數量',
    okr_count: '目標總數',
    overdue: '已逾期',
    complete_kr: '已完成KR',
    key_result_view: '關鍵結果概覽',
    okr_view: '目標概覽',
    to_check_kr: '待校驗KR',
    task_view: '任務概覽',
    task_count: '任務總數',
    due_today: '今日到期',
    y_q_complete: '逾期完成',
    y_q_n_complete: '逾期未完成',
    task_c_z_b: '任務完成占比',
    task_y_q_count: '任務逾期數量',
    kr_core: 'KR 評分分布',
    task_c_num: '任務完成數量',
    not_core: '未評分',
    score_0_3: '0-3分',
    score_4_5: '4-5分',
    okr_num: 'KR數量',
    s_e_required: '開始時間和截止時間必填',
    s_n_m_e_time: '開始時間不能大於截止時間',
    create_okr: '創建目標',
    my_okr_tarte: '我的目標計劃',
    sub_target_okr: '下屬目標計劃',
    pending_task: '待定任務',
    today_work: '今日工作',
    to_determined: '待定',
    year_quarter: '年/季',
    year_plan: '年度計劃',
    week_1: '第1周',
    week_2: '第2周',
    week_3: '第3周',
    week_4: '第4周',
    main_task: '所屬主任務',
    task_properties: '任務屬性',
    task_ref_okr: '任務關聯目標',
    task_ref_kr: '任務關聯KR',
    improvement_plan: '改進計劃',
    demo_info_1: '目標：按照',
    demo_info_2: '關鍵成果（KR）',
    demo_info_3: '來衡量',
    demo_info_4: '任務：我們將通過',
    demo_info_5: '計劃執行（任務）',
    demo_info_6: '來達成關鍵成果（KR）',
    demo_info_7: '套用',
    y_y: '運營',
    s_c: '市場',
    x_s: '銷售',
    r_l: '人力',
    y_f: '研發',
    c_p: '產品',
    c_w: '財務',
    mamage_view: '管理視圖',
    y_b_p: '儀表盤',
    personel_view: '個人視圖',
    change_light: '切換淺色模式',
    change_dark: '切換深色模式',
    see_org_members: '查看組織成員',
    view_dep: '按部門查看',
    view_members: '按成員查看',
    company_okr: '機構目標',
    select_iewer: '選擇查看人員',
    input_key_s_okr: '輸入關鍵字搜索目標',
    show_kr: '顯示KR',
    show_task: '顯示任務',
    show_leavel: '顯示層級',
    show_more: '展示更多',
    now_not_okr: '當前尚未製定目標',
    create_okr_1: '創建目標',
    okr_set: '目標設定',
    okr_result_z_z: '目標結果追蹤',
    okr_result_f_x: '目標結果分析',
    copy_share_link: '復製分享鏈接',
    copy_link: '復製鏈接',
    copy_link_send: '復製鏈接發送，可點擊鏈接查看當前地圖',
    link_addr: '鏈接地址',
    update_x_x: '更新信息指數',
    current_x_x: '當前信心指數',
    x_x_remark: '信心指數說明',
    p_i_x_x_r: '請輸入信心指數說明',
    input_1_10_num: '請輸入1-10之間的數字',
    have_aligned: '已對齊',
    have_split: '已分解',
    not_aligned: '未對齊',
    not_split: '未分解',
    okr_data_detail: '目標數據詳情',
    search_dep_name: '搜索姓名和部門',
    y_b_p_info_1: '目標 填寫率',
    y_b_p_info_2: '填寫率=員工至少已負責一個目標的比例',
    y_b_p_info_3: '目標 對齊率',
    y_b_p_info_4: '對齊率=有關聯母目標的目標比例',
    y_b_p_info_5: '項目執行分解率',
    y_b_p_info_6: '關鍵成果分解=有進行執行任務分解的KR比例',
    y_b_p_info_7: '每個人負責的 目標 數量分布',
    y_b_p_info_8: '單周期內個人負責目標數量1-3個最佳，最多不超過5個',
    y_b_p_info_9: '未設置目標',
    y_b_p_info_10: '1-5個目標',
    y_b_p_info_11: '5個以上目標',
    y_b_p_info_12: '目標下的 KR 數量分布',
    y_b_p_info_13: '每個目標中KR數量以3-5個為最佳',
    y_b_p_info_14: '未設置KR',
    y_b_p_info_15: '1-2個KR',
    y_b_p_info_16: '3-5個KR',
    y_b_p_info_17: '5個以上KR',
    y_b_p_info_18: '目標對齊量',
    y_b_p_info_19: 'KR分解',
    y_b_p_info_20: '一周內未更新的目標',
    y_b_p_info_21: '一周內未更新進展的 目標數量',
    y_b_p_info_22: '一周內未更新的KR',
    y_b_p_info_23: '一周內未更新進展的 KR數量',
    y_b_p_info_24: '一周內未更新的任務',
    y_b_p_info_25: '一周內未更新進展的 執行任務數量',
    y_b_p_info_26: '目標數量',
    y_b_p_info_27: 'KR數量',
    y_b_p_info_28: '總人數',
    y_b_p_info_29: '總目標',
    data_list: '數據列表',
    remind_info:
      '請及時更新 實現機構立足深圳 的計劃執行。\n要求：\n1.針對這個目標做好KR和任務分解\n2.關鍵結果KR是支持目標的重要因素，是可量化的\n3.直擊要點，不要模棱兩可',
    select_dep_view: '選擇部門查看',
    i_know: '我知道了',
    key_to_remind: '一鍵提醒',
    remin_info_1: '提醒成員添加目標',
    remin_info_2: '請盡快添加目標',
    remin_info_3: '提醒目標負責人添加關鍵成果',
    remin_info_4: '請盡快為目標添加關鍵成果',
    remin_info_5: '提醒目標負責人對齊目標',
    remin_info_6: '請盡快為目標添對加齊',
    remin_info_7: '提醒關鍵成果負責人添加執行任務',
    remin_info_8: '請盡快為關鍵成果添加執行任務',
    remin_info_9: '提醒更新目標進展',
    remin_info_10: '請及時更新目標進展，包括當前階段性成果、工作障礙點',
    remin_info_11: '提醒更新關鍵成果進展',
    remin_info_29: '提醒更新執行任務',
    remin_info_30: '請及時更新關鍵成果進展，包括當前階段性成果、工作障礙點',
    remin_info_12: '請及時更新執行任務，包括當前階段性成果、工作障礙點',
    remin_info_13: '提醒目標負責人為關鍵結果KR評分',
    remin_info_14: '請盡快為以下KR進行評分',
    remin_info_15: '未設置目標的成員',
    remin_info_16: '設置1-5個目標的人員',
    remin_info_17: '設置5個以上目標的人員',
    remin_info_18: '未添加關鍵成果的目標',
    remin_info_19: '設置1-2個關鍵成果的目標',
    remin_info_20: '設置5個以上關鍵成果的目標',
    remin_info_21: '設置3-5個關鍵成果的目標',
    remin_info_22: '未添加對齊的目標',
    remin_info_23: '已添加對齊的目標',
    remin_info_24: '未添加執行任務的關鍵成果',
    remin_info_25: '已添加執行任務的關鍵成果',
    remin_info_26: '未進行評分的KR',
    remin_info_27: '評分0-3分的KR',
    remin_info_28: '評分4-5分的KR',
    okr_demo_t_1: '結合目標用戶群體核心需求，提出對當前產品的優化建議，提升用戶使用粘性',
    okr_demo_t_2:
      '梳理現有產品功能使用情況，完成用戶調研報告，明確用戶群體核心需求，提出增強用戶粘性的',
    okr_demo_t_3: '優化現有 XX 標簽體系，推送精準率提高至 40%，平均用戶在線時長提升 20%',
    okr_demo_t_4: '協同產品部門完成相關功能上線，日活躍用戶規模達到 500 萬水平，用戶流失率下降 10%',
    okr_demo_t_5: '實現 XX 產品用戶量與用戶活躍度的提升，為營收增長提供保障',
    okr_demo_t_6: '減少負反饋比例至 10%，客戶留存率提升至 60% ',
    okr_demo_t_7: '上線 XX 活動，鼓勵老用戶回歸，活躍客戶數達到 500 萬 ',
    okr_demo_t_8: '上線拉新相關的 XX 活動，吸引潛在消費者，新增註冊客戶數達 10 萬',
    okr_demo_t_9: '優化 XX 產品的獎勵回饋機製，使得用戶在產品界面的停留時長上升 10% ',
    okr_demo_t_10: '提升 XX 產品的市場知名度',
    okr_demo_t_11: '與 XX 渠道達成新的合作關系，粉絲數量提升 10%',
    okr_demo_t_12: '發布 10 篇閱讀量 5w+ 的高質量公關文章，話題討論參與人數達 100 萬',
    okr_demo_t_13: '通過聯動等活動，提升微博、微信、頭條號等主流媒體的話題活躍度 20% ',
    okr_demo_t_14: '保持 XX 品牌領先優勢，提升品牌知名度與影響力',
    okr_demo_t_15:
      '品牌策略：重新定義 XX 品牌，差異化表達品牌理念，以專項形式落地品牌策略，產出 10 個宣傳素材，總曝光量達到 1 億',
    okr_demo_t_16:
      '品牌宣傳：首月完成 1 支混剪出街視頻，本次 目標 周期結束前完成 XX 新品牌的視頻拍攝',
    okr_demo_t_17:
      '渠道合作：共創頂級 IP 合作（博物館、歷史文化、藝術、公益），吸引 10 個 XX 站粉絲量在 10 萬以上的品牌賬號入駐',
    okr_demo_t_18: '渠道推廣：贊助一場大型公開性活動，吸引1000個公眾號關註',
    okr_demo_t_19: '沈澱創意經驗和品牌管理方法論，輸出中臺支持能力',
    okr_demo_t_20: '完成素材中心系統的搭建，本周期內形成至少 1,000 份創意素材',
    okr_demo_t_21:
      '形成一套高質量的素材撰寫方法論，提升整體員工撰寫素材的效率和質量，至少縮短素材撰寫周期 30%',
    okr_demo_t_22: '通過在新社交媒體上的線上引流活動，提升活躍粉絲數量',
    okr_demo_t_23: '每周至少撰寫 10 篇高質量推文，單篇閱讀量不低於 10 萬，周期內新增粉絲數 5 萬 ',
    okr_demo_t_24:
      '至少開展 10 場線上轉發抽獎活動，單場平均轉發量不低於 1 萬，參與活動的粉絲占比不低於 30% ',
    okr_demo_t_25: '進行推文數據分析，並根據結果調整寫作方式，下半月閱讀量均值比上半月提升 10%',
    okr_demo_t_26: '賦能銷售團隊，提升銷售團隊效率',
    okr_demo_t_27:
      '在 1 月底之前，製定銷售技能認證機製，規範不同技能組合的培訓內容，形成標準化講義，最終確保全體銷售成員通過認證',
    okr_demo_t_28: '豐富銷售團隊梯度，本周期內入職 3 名高級銷售經理',
    okr_demo_t_29: '實施 XX 新流程，縮短正常流程時間至一周以內',
    okr_demo_t_30: '為銷售提供數據分析支持，提供銷售決策建議',
    okr_demo_t_31:
      '平臺搭建 - 建立銷售分析和 BI 商業智能平臺，確保數據的完整性和可提取性，縮短業務數據分析時間 20%',
    okr_demo_t_32: '商機庫建設 - 完成商機庫一期建設，匹配存量客戶，關聯和打通客戶信息',
    okr_demo_t_33:
      '數據報告 - 活動指標、渠道指標和結果指標自動生成摘要報告，並發送給銷售人員，節省銷售人工填寫報告時間 1 小時',
    okr_demo_t_34: '深耕北區市場，銷售額達到 1,000 萬美金，達成機構第一季度銷售額目標',
    okr_demo_t_35:
      '第 1 季度參加 3 次北區行業活動，收獲有效線索 30 條以上，保證線索轉化率不低於 20%',
    okr_demo_t_36: '優化信息同步機製，及時梳理銷售線索和團隊資源，確保信息同步不隔天',
    okr_demo_t_37: '至少 60% 的銷售團隊完成配額',
    okr_demo_t_38: '加大組合銷售策略的推廣力度，確保 40% 以上的營業額來自於預定銷售和套餐銷售',
    okr_demo_t_39: '完成團隊規模和結構升級，本月招聘計劃完成率提升至 80% 以上',
    okr_demo_t_40: '本月至少完成 3 條新招聘渠道的擴展，各渠道每月推送人才線索量應不低於 1,000',
    okr_demo_t_41: '豐富銷售團隊梯度，本周期內入職 3 名高級銷售經理',
    okr_demo_t_42: '完成機構緊缺人才的招募，本月招聘完成率不低於 90% ',
    okr_demo_t_43: '優化高管團隊的薪酬方案，提高薪酬方案的激勵性',
    okr_demo_t_44:
      '完成對高管團隊的薪酬滿意度調研，覆蓋率需達到 95%，基於調研結果製定一套薪酬方案優化建議書，獲得董事會批準通過 ',
    okr_demo_t_45: '對標同行業最佳實踐，完成股權激勵方案的設計，並獲董事會批準通過',
    okr_demo_t_46:
      '推廣實施新的薪酬方案，落地 2 個月後進行第二次薪酬滿意度調研，滿意度不低於 90%，並基於調研結果提出至少 5 條被董事會采納的可行性改進建議',
    okr_demo_t_47: '優化現有培訓知識體系和平臺，形成「全員學習」的機構文化',
    okr_demo_t_48: '搭建線上培訓平臺並推廣落地，高層試點覆蓋率不低於 95%，全員覆蓋率不低於 60%',
    okr_demo_t_49: '擴充現有培訓知識庫，每月需至少產出 10 套精品課程，課程內容滿意度不低於 90%',
    okr_demo_t_50:
      '優化現有的培訓考核體系，倡導「全員學習」的理念，3 個月內全員平均培訓參與度和各類考試平均分值通過率不低於 80%',
    okr_demo_t_51: '為 XX 業務提供高效穩定的系統支持',
    okr_demo_t_52: '優化 XX 算法，縮短系統對客戶需求的響應時間至 0.1 秒，同時維持 Bug 率不變',
    okr_demo_t_53: 'XX 方案平穩落地，Bug 率控製在 3% 之內，系統無重大事故',
    okr_demo_t_54: '新建 XX 評估方案與 XX 模型，實現「系統穩定性」的可量化統計分析',
    okr_demo_t_55: '打造完善的企業數據中臺，實現所有產品數據的可積累、可溯源',
    okr_demo_t_56: '完成數據中臺框架設計與方案設計，獲得高管層、業務端一致通過 ',
    okr_demo_t_57: '完成數據中臺初代版本的模型搭建，穩定性保持在 99.9% 以上，無重大事故',
    okr_demo_t_58: '初代版本達成後實現主營業務各環節數據 100% 可溯源、可統計',
    okr_demo_t_59: '為即將開始的 XX 業務儲備好充分的研發人才',
    okr_demo_t_60: '招聘測試工程師 10 人（滿足 XX 要求），提升團隊 XX 能力',
    okr_demo_t_61: '從一線大廠招聘有相似業務經歷的 Leader 1 人，帶來成熟的業務經驗',
    okr_demo_t_62: '新業務組全員進行 XX 課程培訓並全部通過測試（60 分），確保 XX 能力達標',
    okr_demo_t_63: '進軍 XX 賽道，完成賽道內初代產品設計',
    okr_demo_t_64: '通過調研用戶圈層，提煉用戶核心需求，輸出相關統計結果',
    okr_demo_t_65: '根據調研結果，確定產品 XX 發展方向，並輸出產品方案，獲得各團隊認可',
    okr_demo_t_66: '進行灰度測試並優化產品，在周期內提升測試用戶滿意度至 90% ',
    okr_demo_t_67: '完成產品基礎能力優化，提升用戶滿意度',
    okr_demo_t_68: '調整 XX 體系，優化 XX 功能，用戶滿意度從 85% 提升至 90% ',
    okr_demo_t_69: '引入 XX 系統，強化產品 XX 能力 ，打通與業務團隊 XX 的數據',
    okr_demo_t_70: '完成產品需求的排期，明確當前所有需求的實現順序，保證 P0 需求如期完成',
    okr_demo_t_71: '優化 XX 產品的重點功能和體驗，充分滿足商業化要求',
    okr_demo_t_72: 'X 月 X 日前完成 XX 功能，滿足 XX 應用商店上架標準',
    okr_demo_t_73: '在本次 目標 周期前，打通 Y 產品的賬戶，支持免註冊登錄，免註冊用戶占比達到 20% ',
    okr_demo_t_74: '上架 1 個月內完成 2 個關鍵功能的 A/B 測試，提升平均頁面留存率至 20% ',
    okr_demo_t_75: '建立規範的預算管理體系，提升預算監控能力',
    okr_demo_t_76:
      '完成機構整體預算項目的梳理，明確預算項目和核算項目之間的映射關系，搭建一套完整、清晰的預實對比和分析體系（例如：明確分析周期、維度等）',
    okr_demo_t_77:
      '新版財務日報上線，展示科目和維度需進一步細化（依 XX 會議商定標準），數據更新周期縮短至 T+8',
    okr_demo_t_78: '預算監控功能上線，各部門覆蓋率達到 100%，月均預警次數不低於 5 次',
    okr_demo_t_79: '優化費用管控體系，提升業務部門差旅滿意度',
    okr_demo_t_80:
      '完成同業最佳實踐調研和機構內部滿意度調研報告，首月末前提出針對管控優化方案的 5 點建議',
    okr_demo_t_81: '基於優化方案建議，設計一套費用管控優化方案並推廣實施，獲得不同業務部門的認可 ',
    okr_demo_t_82:
      '上線商旅系統，優化報銷體驗，縮短報銷流程和時長至少 50%，業務部門差旅滿意度提升 50% ',
    okr_demo_t_83: '搭建財務共享服務中心，實現財務團隊的降本、增效、轉型',
    okr_demo_t_84:
      '引入咨詢機構和技術機構，設計財務共享服務方案與平臺，方案中需明確節省的人員成本和運轉效率的提升程度 ',
    okr_demo_t_85:
      '落地財務共享服務方案，完成財務人員的集中管理，至少覆蓋集團下屬 80% 以上的子機構',
    okr_demo_t_86:
      '完成 SSC 人員的職能專業化分工，效率提升比例不低於 50%（總工時統計）；以及本地財務人員的釋放和業務轉型，釋放和轉型比例不低於 30%',
    f_p_obj: '復盤對象',
    f_p_content: '復盤內容',
    reference_data: '關聯數據',
    edit_plan: '改進計劃',
    create_action_plan: '創建行動計劃',
    f_p_info_1: '價值與收獲',
    f_p_info_2: '我們從過程中學到了什麽新東西?',
    f_p_info_3: '如果有人要進行同樣的行動, 我會給他什麽建議?',
    f_p_info_4: '問題與不足',
    f_p_info_5: '請描述出現的某個問題並針對該問題展開分析',
    f_p_info_6: '根本原因',
    f_p_info_7: '請填寫問題出現的根本原因',
    f_p_info_8: '相應解決措施',
    f_p_info_9: '請根據上述原因給出可落地的解決措施',
    f_p_c_not_empty: '復盤內容不能為空！',
    task_personnel_principal: '任務負責人',
    kr_key_result: '關鍵結果',
    okr_y_q: '逾期',
    alignKr: '對齊KR',
    belong_to_okr: '所屬目標',
    okrNameRoleCreattime: '目標名稱、角色、創建時間',

    // 2022-05-31
    systemAutoComHours: '系統自動計算消耗工時，在完成任務後計算',
    yixiaohao: '已消耗',
    plan_time: '計劃工時',
    recommend_progress: '推薦進度',
    reference_form_data: '關聯表單數據',
    restart_task: '重啟任務',
    update_progress: '更新進度',
    update_task_hours: '更新任務工時',
    the_use: '本次使用',
    expected_time: '預計工時',
    stop_task: '暫停任務',
    hours_not_empty: '工時不能為空',
    hours_not_zero: '工時不能等於0',
    hours_less_zero: '工時不能小於0',
    task_completion_time_requried: '任務完成時間必填',
    task_completion_time: '任務完成時間',
    task_plan_time: '任務計劃工時',
    my_align: '我對齊的',
    cancel_align: '取消對齊',
    company_level: '機構級',
    department_level: '部門級',
    team_level: '團隊級',
    personal_level: '個人級',
    plan_time_1decimal: '計劃工時最多1位小數',
    name_not_exist_again: '名稱不存在，請重新輸入',
    okr_input_tips: '表明要做一件什麽事，@邀請他人',
    min_value: '門檻值',
    okr_value: '目標值',
    max_value: '挑戰值',
    kr_input_tips: '達成目標要實現的關鍵性成果，輸入@邀他人',
    save_continue_add: '保存後繼續添加',
    okr_reader_type_1: '本部門(僅限直屬人員)和所有上級',
    okr_reader_type_2: '本部門(包含所有下級成員)和所有上級',
    okr_reader_type_3: '僅限自己和上級',
    kr_weight_error_1: 'KR權重輸入有誤',
    kr_weight_error_2: 'KR權重最多兩位小數',
    okr_check_1: '目標類型必填',
    okr_check_2: 'KR關鍵成果不能為空',
    okr_check_3: '自定義可見範圍必填',
    okr_check_4: '績效指標必須滿足【挑戰值>=目標值>=門檻值】',
    okr_check_5: 'KR權重之和必須為100%',
    okr_review: '目標復盤',
    system_period_auto_progress: '系統根據目標周期自動計算',
    kr_result: 'KR關鍵成果',
    open_task: '展開任務',
    show_complate_task: '顯示完成任務',
    focus_on: '關註',
    kr_period: 'KR周期',
    complate_kr_task: '已完成任務/KR下任務',
    no_okr_value_set: '未設置目標值',
    performance_zhibiao: '績效指標',
    kr_head: 'KR負責人',
    hand_update_kr_progress: '手動更新KR進度',
    task_progress_auto_update: '按任務進度自動更新',
    sub_okr_auto_update: '按子目標進度自動更新',
    kr_progress_auto_update: '按KR的進度自動更新',
    kr_sorting: 'KR排序',
    del_okr_tips: '確定要刪除該目標嗎？刪除後目標以及KR和KR下的所有任務將同步刪除',
    jxzb_tips: '績效指標必須滿足【挑戰值>=目標值>=門檻值】',
    cancel_liked: '取消點贊',
    cancel_collected: '取消收藏',
    task_progress: '任務進度',
    system_auto_computed: '系統自動計算',
    system_auto_record: '系統自動記錄',
    tokr_count: '目標數',
    risk_of_delay: '延遲風險',
    okr_complate_count: '目標完成度',
    okr_complate_tip: '目標完成度=所有目標進度之和/目標數量',
    kr_result_count: 'KR成果數',
    without_update_10days_kr: '10天未更新占比KR',
    show_kr_1: '展示KR',
    show_organ_name: '展示組織名稱',
    operation_key: '操作快捷鍵',
    dblclick: '鼠標雙擊',
    screen_delay_tip: '已為您篩選出【延遲風險】的',
    blueprint_perspective: '藍圖視角',
    input_kr_name: '請輸入目標名稱',
    zhibiao: '指標',
    system_kr_period_auto: '系統根據KR周期自動計算',
    used_hours: '使用工時',
    task_period: '任務周期',
    edit_kr: '編輯KR',
    del_task_tips: '確定要刪除該任務嗎？刪除後當前任務以及任務下的子任務將同步刪除',
    del_kr_tips: '確定要刪除該KR嗎？刪除後KR和KR下的所有任務將同步刪除',
    not_okr_tips_1: '尚未製定目標，立即',
    not_okr_tips_2: '製定目標',
    not_okr_tips_3: '如果你不知道如何製定目標，從',
    not_okr_tips_4: '目標管理 案例庫導入',
    okr_visible_range: '目標可見範圍',
    percent_progerss: '進度占比',
    all_kr_weight_100: 'KR權重之和必須為100%',
    okr_type_not_change: '目標類型未發生變更，不可點擊確定按鈕',
    visible_personnel: '可見人員',
    progress_type: '進度類型',
    select_one_okr: '請最少選擇一條子目標',
    okr_progress_count_100: '勾選目標的進度占比和必須為100%',
    change_kr_weight: 'KR權重調整%',
    change_jxzb: '績效指標調整%',
    all_users: '所有人員',
    base_setting: '基礎設置',
    base_setting_tip_1: '目標管理功能控製',
    base_setting_tip_2: '標準版',
    base_setting_tip_3: '高級版',
    base_setting_tip_4: '機構級目標',
    base_setting_tip_5: '誰可以創建機構級目標',
    base_setting_tip_6: '機構負責人',
    base_setting_tip_7: '部門級目標',
    base_setting_tip_8: '誰可以創建部門級目標',
    base_setting_tip_9: '部門負責人（包含負責的所有下級部門）',
    base_setting_tip_10: '團隊級目標',
    base_setting_tip_11: '誰可以創建團隊級目標',
    base_setting_tip_12: '個人級目標',
    base_setting_tip_13: '誰可以創建個人級目標',
    base_setting_tip_14: '設置績效管理員',
    base_setting_tip_15: '目標設置',
    base_setting_tip_16: '目標關聯KR',
    base_setting_tip_17: '開啟後，目標可關聯其它目標的關鍵成果KR',
    base_setting_tip_18: '目標進度自動更新',
    base_setting_tip_19: '開啟後，顯示目標進度自動更新設置，目標進度支持自動更新',
    base_setting_tip_20: 'KR詳情',
    base_setting_tip_21: '開啟後，點擊KR顯示KR詳情頁，未開啟則不彈窗顯示KR詳情頁',
    base_setting_tip_22: '電子簽章',
    base_setting_tip_23: '開啟後，將在目標下顯示電子簽章功能，目標或KR需要電子簽章',
    base_setting_tip_24: '目標類型',
    base_setting_tip_25: '開啟後，可選擇目標為機構級、部門級和個人級，通過類型區分目標',
    base_setting_tip_26: '開啟後，目標詳情界面顯示文件頁簽，可上傳文件',
    base_setting_tip_27: '任務設置',
    base_setting_tip_28: '開啟後，將在KR下啟用任務功能',
    base_setting_tip_29: '任務完成允許修改完成時間',
    base_setting_tip_30: '開啟後，將在點擊完成任務時間選擇完成時間，否則不可選擇',
    base_setting_tip_31: '任務完成校驗',
    base_setting_tip_32: '開啟後，在任務點擊完成後觸發校驗，校驗通過後任務才算已完成',
    base_setting_tip_33: '任務工時系統自動計算',
    base_setting_tip_34:
      '開啟後，任務的使用工時系統自動計算，與考勤模塊對接，請使用「考勤」模塊進行排班；若任務執行人未排班，則使用工時無法自動計算',
    base_setting_tip_35: '績效考核',
    base_setting_tip_36: '績效申訴',
    base_setting_tip_37: '開啟後，被考核人在考核結束後可對考核結果發起申訴',
    base_setting_tip_38: '績效改進',
    base_setting_tip_39: '開啟後，對考核內容進行績效復盤',
    base_setting_tip_40: '績效管理員',
    base_setting_tip_41: '開啟後，績效管理員可使用績效所有功能',
    base_setting_tip_42: '預發布',
    base_setting_tip_43: '開啟後，發起考核支持預發布功能，可提前公布考核事項並實時獲取完成值',
    base_setting_tip_44: '請先開啟KR詳情功能',
    base_setting_tip_45: '請先開啟任務功能',
    base_setting_tip_46: '目標類型設置',
    strategic_blueprint: '目標地圖',
    create_new_kr: '新建KR',
    create_new_okr: '新建目標',
    sure_del_current_okr: '確定要刪除當前目標嗎？',
    tokr_preview: '目標管理視圖',
    dont_move_kr_okr: '請不要將目標和KR交叉拖動，此操作是無效拖動',
    review_type: '復盤類型',
    review_okr: '復盤目標',
    upload_file: '上傳附件',
    the_next_steps: '下一步行動',
    okr_review_type_1: '臨時復盤',
    okr_review_type_2: '當天復盤',
    okr_review_type_3: '周例會復盤',
    okr_review_type_4: '月度列會復盤',
    okr_review_type_5: '季度復盤',
    del_review_tips: '確定要刪除該目標復盤嗎？',
    create_review: '新建復盤',
    okr_role: '目標所屬角色',
    okr_department: '目標所屬部門',
    select_align: '選擇目標',
    align_okr_not_empty: '對齊目標不能為空',
    teamface_okr: '目標管理',
    initiate: '發起',
    not_auth_contact_admin: '你無權查看該模塊,請聯系管理員',
    my_assessment: '我的考核',
    my_score: '我的評分',
    performance_improvement: '績效改進',
    performance_complaint: '績效申訴',
    assessment_management: '考核管理',
    performance_templete: '績效模板',
    performance_statistics: '績效統計',
    personnel: '組織',
    operate: '運營',
    SystemUsageExpirationTime1: '系統使用到期時間',
    SystemUsageExpirationTime2: '請盡快聯系工作人員，否則到期後系統將不可登錄',
    Noreminders: '不再提醒',
    myTarget: '我的目標',
    targetMap: '目標地圖',
    targetMultiple: '目標復盤',
    Organization: '組織管理',
    Employee: '員工管理',
    Salary: '薪酬管理',
    Personnelhandled: '人事待辦',
    Myprofile: '我的檔案',
    personnelNameNotEmpty: '人事待辦名稱不能為空',
    personneleContentNotEmpty: '人事待辦內容不能為空'
  }
}
